<div class="private-layout__sidebar">
	<div class="container">
		<div class="row">
			<div class="col-auto">
				<img [src]="profileAvatar"
					class="private-layout__sidebar-avatar rounded-circle"
					alt="profileAvatar" />
			</div>
			<div class="col-6 d-flex flex-column">
				<span class="text--md text--xl-weight">{{ profileName }}</span>
				<span class="text--md text--lg-weight"> {{ userCounty }}</span>
				<form [formGroup]="availForm">
					<div class="custom-control custom-switch mt-4">
						<label class="switch d-flex align-items-center">
							<input type="checkbox"
								formControlName="availability"
								id="availability"
								name="availability"
								value="availability">
							<span class="slider round"></span>
							<label class="ml-18 mb-0 text-nowrap text--sm-weight"
								for="availability">Status aktywności</label>
						</label>
					</div>
				</form>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<ul *ngIf="!isEditor()"
					class="list-unstyled private-layout__sidebar-list">
					<li class="mb-12"
						*ngFor="let item of sidebarItems">
						<ng-container *ngIf="!item.href">
							<img [src]="item.image"
								class="mr-6" />
							<a [routerLink]="[item.link]"
								class="private-layout__sidebar-link text--md"> {{ item.name }} </a>
						</ng-container>
						<ng-container *ngIf="item.href">
							<img [src]="item.image"
								class="mr-6" />
							<a [href]="[item.href]"
								class="private-layout__sidebar-link text--md"> {{ item.name }} </a>
						</ng-container>
					</li>
				</ul>
				<ul *ngIf="isEditor()"
					class="list-unstyled private-layout__sidebar-list">
					<li class="mb-12"
						*ngFor="let item of editorSidebarItems">
						<ng-container *ngIf="!item.href">
							<img [src]="item.image"
								class="mr-6" />
							<a [routerLink]="[item.link]"
								class="private-layout__sidebar-link text--md"> {{ item.name }} </a>
						</ng-container>
						<ng-container *ngIf="item.href">
							<img [src]="item.image"
								class="mr-6" />
							<a [href]="[item.href]"
								class="private-layout__sidebar-link text--md"> {{ item.name }} </a>
						</ng-container>
					</li>
				</ul>
			</div>
		</div>
	</div>
</div>
<!-- <div class="db-admin">
	<div class="dashboard-nav">
		<div class="dashboard-nav-inner">
			<ul data-submenu-title="Główne">
				<li class="active">
					<a [routerLink]="['/admin/dashboard']"
						><i class="fa fa-tachometer"></i> Panel główny</a
					>
				</li>
			</ul>
			<ul
				*ngIf="isSubskrybent() || isAdministrator() || isGuest()"
				data-submenu-title="Zakładki"
			>
				<li>
					<a [routerLink]="['/gallery']"
						><i class="fa fa-calendar-check-o"></i>Moja galeria
						zdjęć</a
					>
				</li>
				<li>
					<a [routerLink]="['/trip-planner/manage/list']"
						><i class="fa fa-star"></i>Moje przejazdy</a
					>
				</li>
				<li>
					<a [routerLink]="['/articles/manage/list']"
						><i class="fa fa-bookmark"></i>Moje artykuły</a
					>
				</li>
				<li>
					<a [routerLink]="['/blog/manage/list']"
						><i class="fa fa-th-large"></i>Mój blog</a
					>
				</li>
			</ul>
			<ul
				*ngIf="isRedaktor() || isAdministrator()"
				data-submenu-title="Moderacja"
			>
				<li>
					<a [routerLink]="['/trip-planner/manage/admin']"
						><i class="fa fa-bookmark"></i>Przejazdy</a
					>
				</li>
				<li *ngIf="isRedaktor()">
					<a [routerLink]="['/articles/manage/list']"
						><i class="fa fa-bookmark"></i>Artykuły</a
					>
				</li>
				<li *ngIf="isRedaktor()">
					<a [routerLink]="['/blog/manage/list']"
						><i class="fa fa-th-large"></i>Blog</a
					>
				</li>
				<li *ngIf="isRedaktor()">
					<a [routerLink]="['/comments/manage/list']"
						><i class="fa fa-th-large"></i>Komentarze</a
					>
				</li>
			</ul>
			<ul data-submenu-title="Konto">
				<li>
					<a [routerLink]="['/account/profile']"
						><i class="fa fa-user"></i> Mój Profil</a
					>
				</li>
				<li>
					<a [routerLink]="['/account/my-subscriptions']"
						><i class="fa fa-user"></i> Moje subskrypcje</a
					>
				</li>
				<li>
					<a *ngIf="!isUserLogged" [routerLink]="['/account/login']"
						><i class="fa fa-sign-in"></i> Zaloguj się</a
					>
				</li>

				<li>
					<a *ngIf="isUserLogged" [routerLink]="['/account/voucher']"
						><i class="fa fa-lock"></i> Zrealizuj kod Trekmondo</a
					>
				</li>
				<li>
					<a
						*ngIf="isUserLogged"
						[routerLink]="['/account/change-password']"
						><i class="fa fa-lock"></i> Zmień hasło</a
					>
				</li>
			</ul>
		</div>
	</div>
</div>
<a class="db-trigger" (click)="toggleMenu()">
	<i class="fa fa-reorder"></i>
</a> -->
